import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['sidebarContainer', 'mainContainer', 'label']

  toggle() {
    if (this.sidebarContainerTarget.dataset.expanded === '1') {
      this.collapse()
    } else {
      this.expand()
    }
  }

  collapse() {
    this.sidebarContainerTarget.classList.remove('w-48')
    this.mainContainerTarget.classList.remove('left-48', 'pr-48')
    this.mainContainerTarget.classList.add('left-12', 'pr-12')
    this.labelTargets.forEach((label) => {
      label.classList.add('sr-only')
    })
    this.sidebarContainerTarget.dataset.expanded = '0'
  }

  expand() {
    this.sidebarContainerTarget.classList.add('w-48')
    this.mainContainerTarget.classList.remove('left-12', 'pr-12')
    this.mainContainerTarget.classList.add('left-48', 'pr-48')

    this.labelTargets.forEach((label) => {
      label.classList.remove('sr-only')
    })
    this.sidebarContainerTarget.dataset.expanded = '1'
  }
}
